<template>
  <markdown-view-teacher :raw-text="markdownText" ref="refMarkdownView"></markdown-view-teacher>
</template>

<script setup lang="ts">
  import {ref, onMounted, onUpdated, nextTick} from "vue";

  const props = withDefaults(
    defineProps<{
      markdownText: string;
      prefix?: string;
    }>(),
    {
      prefix: "",
    }
  )
  const refMarkdownView = ref(null)
  onMounted(() => {
    convertIntoPlainText()
  })

  onUpdated(() => {
    convertIntoPlainText()
  })

  function convertIntoPlainText() {
    nextTick(() => {
      // タグのみ削除
      refMarkdownView.value.$el.innerHTML = refMarkdownView.value.$el.innerHTML.replace(/<u>|<\/u>|<em>|<\/em>|<strong>|<\/strong>|<p .*?>|<p>|<\/p>|<br>|<br \/>/g, "")
      // タグとタグで囲まれた範囲をまとめて削除
      refMarkdownView.value.$el.querySelectorAll("rt, img, audio, video").forEach(ele => ele.remove())
      refMarkdownView.value.$el.innerHTML = props.prefix + " " + refMarkdownView.value.$el.innerHTML
    })
  }
</script>

<style lang="scss" scoped>
</style>
